import slide4 from "../../../Assets/Images/homepage/images/education.webp";
import slide3 from "../../../Assets/Images/homepage/images/enterTainment.jpg";
import slide6 from "../../../Assets/Images/homepage/images/fbInsta.jpg";
import slide1 from "../../../Assets/Images/homepage/images/imagefs.jpg";
import slide5 from "../../../Assets/Images/homepage/images/religion.jpg";
import slide2 from "../../../Assets/Images/homepage/images/socialMedia.jpg";
import Liton from "../../../Assets/Images/nestedCategory/liton.jpg";
import Mashrafee from "../../../Assets/Images/nestedCategory/mashrafee.jpg";
import Musfiq from "../../../Assets/Images/nestedCategory/musfiq.jpg";
import Shakib from "../../../Assets/Images/nestedCategory/Shakib-Al-Hasan.webp";
import Tamim from "../../../Assets/Images/nestedCategory/tamim.jpg";
import Taskin from "../../../Assets/Images/nestedCategory/taskin.jpg";

export const fakeCategoryData = [
  {
    id: 1,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 2,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 3,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 4,
    slider: slide4,
    categoryName: "Education",
  },
  {
    id: 5,
    slider: slide5,
    categoryName: "Religion",
  },
  {
    id: 6,
    slider: slide6,
    categoryName: "Social Media",
  },
  {
    id: 7,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 8,
    slider: slide2,
    categoryName: "LiveNews",
  },
];

export const sportCategoryData = [
  {
    id: 1,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 2,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 3,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 4,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 5,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 6,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 7,
    slider: slide1,
    categoryName: "Sports",
  },
  {
    id: 8,
    slider: slide1,
    categoryName: "Sports",
  },
];

export const liveNewsData = [
  {
    id: 1,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 2,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 3,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 4,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 5,
    slider: slide2,
    categoryName: "Live News",
  },
  {
    id: 6,
    slider: slide2,
    categoryName: "Live News",
  },
];

export const entertainmentData = [
  {
    id: 1,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 2,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 3,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 4,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 5,
    slider: slide3,
    categoryName: "Entertainment",
  },
  {
    id: 6,
    slider: slide3,
    categoryName: "Entertainment",
  },
];

export const educationData = [
  {
    id: 1,
    slider: slide4,
    categoryName: "Entertainment",
  },
  {
    id: 2,
    slider: slide4,
    categoryName: "Entertainment",
  },
  {
    id: 3,
    slider: slide4,
    categoryName: "Entertainment",
  },
  {
    id: 4,
    slider: slide4,
    categoryName: "Entertainment",
  },
  {
    id: 5,
    slider: slide4,
    categoryName: "Entertainment",
  },
  {
    id: 6,
    slider: slide4,
    categoryName: "Entertainment",
  },
];

export const nestedCategoryData = [
  {
    id: 1,
    slider: Liton,
    categoryName: "Liton Das",
  },
  {
    id: 2,
    slider: Shakib,
    categoryName: "Shakib Al Hasan",
  },
  {
    id: 3,
    slider: Taskin,
    categoryName: "Taskin Ahmed",
  },
  {
    id: 4,
    slider: Tamim,
    categoryName: "Tamim Iqbal",
  },
  {
    id: 5,
    slider: Musfiq,
    categoryName: "Musfiqur Rahim",
  },
  {
    id: 6,
    slider: Mashrafee,
    categoryName: "Mashrafee Mortaza",
  },
];
